import makeStyles from '@mui/styles/makeStyles';

const useInverterViewGraphStyles = makeStyles({
  root: {
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      boxShadow: "4px 4px 15px rgba(0, 0, 0, 0.05)",
      borderRadius: "50px",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },
    
    "& .MuiInputBase-root": {
      color: "#000",
      backgroundColor: "transparent",
      borderRadius: "50px",
      border: "none",
      fontSize:'12px'
    },
    "& MuiPickersDay-daySelected": {
      backgroundColor: "white",
      border: "none",
      "&:hover": {
        backgroundColor: "white",
        border: "none",
      },
    },

    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent', // Hide the default underline
    },
    '& .MuiTab-root': {
      backgroundColor: '#f0f0f0', // Background color for all tabs
      color: 'black', // Font color for all tabs
      fontSize: '13px', // Font size for all tabs
      padding: '1px 4px', // Padding for all tabs
      height: '25px', // Specific height for all tabs
      minHeight: '25px',
      margin: '0px 5px',
      borderRadius: '4px'
      
    },
    '& .Mui-selected': {
      backgroundColor: 'rgba(89, 104, 183, 0.25)', // Background color for the active tab
      color: 'black', // Font color for the active tab
    },
    '& .MuiButtonBase-root-MuiTab-root': {
      height: '25px',
      minHeight: '25px',
    },
    '& .MuiTabs-root': {
      height: '25px',
      minHeight: '25px',
    }
  },
  datePicker: {
    color: "#000",
    backgroundColor: "white",
    border: "none",
    boxShadow: "1px 4px 15px rgba(0, 0, 0, 0.05)",

    "& .MuiOutlinedInput-root": {
      border: "none",
      height: "40px",
      width: "130px",
    },
    "& .MuiOutlinedInput-input": {
      border: "none",
      padding: "5px",
    },
  },
  largedatePicker: {
    color: "#000",
    backgroundColor: "white",
    border: "none",
    boxShadow: "1px 4px 15px rgba(0, 0, 0, 0.05)",

    "& .MuiOutlinedInput-root": {
      border: "none",
      height: "40px",
      width: "200px",
    },
    "& .MuiOutlinedInput-input": {
      border: "none",
      padding: "5px",
    },
  },
});

export default useInverterViewGraphStyles;
